export default __webpack_public_path__ + "static/media/protection.aaa17baa.svg";